$(document).ready(function () {
  (adsbygoogle = window.adsbygoogle || []).push({});
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/google_ads_push_fix.js